var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { NotFoundError } from '@lucidlink/sdk/fetcher';
import { Avatar, Box, Button, DrawerEmptyState, LoadingBox, Trans, translate, Typography, UserXIcon, } from '@lucidlink/uicore';
import { PII_MASK_CLASS } from '#constants';
import { useDeleteGuestLinkAcl } from '../../query-hooks/mutations/useDeleteGuestLinkAcl';
import { useGetGuest } from '../../query-hooks/queries/useGetGuest';
import { useGuestLinksFsEntryGetPathBulk } from '../../query-hooks/queries/useGuestLinksFsEntryGetPathBulk';
import { DrawerActions } from './DrawerActions';
import { GuestLinksList } from './GuestLinksList';
import { GuestDetailsDrawerTestIdFactory } from './interactions';
export const GuestDetailsDrawerContent = ({ closeDrawer, filespaceId, guestEmail, workspaceId, }) => {
    _react_refresh_temp_2();
    const { data, error, isError, isPending, refetch } = useGetGuest({ filespaceId, workspaceId }, guestEmail);
    const { mutate: deleteGuestLinkAcl } = useDeleteGuestLinkAcl({
        filespaceId,
        workspaceId,
    });
    const links = useMemo(() => data?.links ?? [], [data]);
    const pathQueriesByEntryId = useGuestLinksFsEntryGetPathBulk({
        filespaceId,
        links,
        workspaceId,
    });
    useEffect(() => {
        /**
         * Using effect instead of handling the removal of the last link
         * because someone from a different machine might remove the last link
         * and we want to react when the list is empty
         */
        if (error instanceof NotFoundError || (data && !data.links.length)) {
            closeDrawer();
        }
    }, [closeDrawer, data, error]);
    if (isPending) {
        return (_jsx(LoadingBox, { alt: translate('loading data'), "data-testid": GuestDetailsDrawerTestIdFactory.getLoadingTestId(), isFullHeight: true, isFullWidth: true, justify: "center" }));
    }
    if (isError) {
        return (_jsx(DrawerEmptyState, { color: "red", "data-testid": GuestDetailsDrawerTestIdFactory.getLoadErrorTestId(), Icon: UserXIcon, message: _jsx(Trans, { children: "An error occurred. The guest couldn\u2019t be loaded." }), children: _jsx(Button, { "data-testid": GuestDetailsDrawerTestIdFactory.getRetryTestId(), kind: "primary", onClick: () => void refetch(), size: "big", children: _jsx(Trans, { children: "Retry" }) }) }));
    }
    const { linksCount } = data;
    const isEveryLinkBeingRemoved = links.every((link) => link.isOptimistic);
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { gap: "l", grow: 1, isFullWidth: true, orientation: "vertical", scrollableY: true, children: [_jsxs(Box, { align: "center", gap: "s", isFullWidth: true, children: [_jsx(Avatar, { "data-testid": GuestDetailsDrawerTestIdFactory.getGuestAvatarTestId(), id: guestEmail, size: "small", value: guestEmail }), _jsx(Typography, { className: PII_MASK_CLASS, color: "accent", "data-testid": GuestDetailsDrawerTestIdFactory.getGuestEmailTestId(), kind: "generic-small", children: guestEmail })] }), _jsx(GuestLinksList, { links: links, linksCount: linksCount, onRemove: (link) => deleteGuestLinkAcl({
                            email: guestEmail,
                            guestLinkId: link.id,
                        }), pathQueriesByEntryId: pathQueriesByEntryId })] }), _jsx(DrawerActions, { closeDrawer: closeDrawer, email: guestEmail, filespaceId: filespaceId, isRemoveFromAllLinksDisabled: isEveryLinkBeingRemoved, lastUsedAt: data.lastUsedAt, workspaceId: workspaceId })] }));
};
_react_refresh_temp_1 = GuestDetailsDrawerContent;
$RefreshReg$(_react_refresh_temp_1, "GuestDetailsDrawerContent");
_react_refresh_temp_2(GuestDetailsDrawerContent, "HXmt8HNkhxEtH2ZHwy5ORYDlGCw=", false, () => [useGetGuest, useDeleteGuestLinkAcl, useGuestLinksFsEntryGetPathBulk]);
